export const SPLATFileLoaderMetadata = {
    name: "splat",
    extensions: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ".splat": { isBinary: true },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ".ply": { isBinary: true },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ".spz": { isBinary: true },
    },
};
//# sourceMappingURL=splatFileLoader.metadata.js.map